<template>
  <dea-top-header auto-redirect-to-login always-call-on-identification>
    <div slot="main-menu">
      <header class="site-header site-header--dea">
        <div class="dea-main-header dea-main-header--dea">
          <div class="dea-main-header__additional-info">
            <h2 class="dea-main-header__main-title">I miei eventi</h2>
          </div>
        </div>
      </header>
    </div>
  </dea-top-header>
</template>
<script>
export default {
  name: "Header",
  components: {},
  props: {},
  mounted() {
    const main = document.querySelector(".site-main");
    const mobileMenuTrigger = document.querySelectorAll("#js-mobile-catalog-menu-trigger, #js-mobile-menu-trigger");
    const mobileMenuClose = document.querySelector(".js-mobile-menu-close");
    const mobileMenu = document.querySelectorAll(".mobile-catalog-menu, .mobile-menu");

    function menuOpen() {
      if (mobileMenu) {
        mobileMenu.addClass("active");
      }
      if (main) {
        main.addClass("mobile-menu-active");
      }
    }

    function menuClose() {
      if (mobileMenu) {
        mobileMenu.removeClass("active");
      }
      if (main) {
        main.removeClass("mobile-menu-active");
      }
    }
    if (mobileMenuTrigger) {
      mobileMenuTrigger.forEach(mobileMenuTriggerelement => mobileMenuTriggerelement.on("click", menuOpen));
    }
    if (mobileMenuClose) {
      mobileMenuClose.on("click", menuClose);
    }
  },
};
</script>
